const snackbar = {
  namespaced: true,

  state: {
    title: 'default',
    color: 'primary',
    visible: false
  },

  mutations: {
    SET_SNACKBAR(state, payload) {
      state.title = payload.title
      state.color = payload.color
      state.visible = true
    },
    UPDATE_VISIBLE(state, payload) {
      state.visible = payload
    }
  },

  actions: {},

  getters: {
    getSnackBarState: state => {
      return {
        title: state.title,
        color: state.color,
        visible: state.visible
      }
    }
  }
}

export default snackbar
